import clsx from "clsx";

export function Bounded({
  as: Comp = "div",
  size = "base",
  className,
  id,
  children,
}) {
  return (
    <Comp
      id={id}
      className={clsx("px-4 py-8 md:px-6 md:py-10 lg:py-10", className)}
    >
      <div
        className={clsx(
          "mx-auto w-full",
          size === "small" && "max-w-xl",
          size === "base" && "max-w-3xl",
          size === "wide" && "max-w-4xl",
          size === "wider" && "max-w-6xl",
          size === "widest" && "max-w-7xl",
          size === "full" && "max-w-full"
        )}
      >
        {children}
      </div>
    </Comp>
  );
}
